import {useUserContext} from 'authentication/UserContext';
import {
	CompareResult,
	IComparedItem,
	IParagraphCompareInput,
} from '../compareDocuments/compareDocuments';
import {useCallback} from 'react';

export const useComparisonFilter = () => {
	const {isVex, myVexClusters} = useUserContext();

	const filterByStatus = (compareResult: IComparedItem[], toggles: any) => {
		const {showDeleted, showNew, showChanged, showEqual, showInReview} =
			toggles;
		const items = compareResult.filter(item => {
			// If no filters are selected
			if (
				!showDeleted &&
				!showNew &&
				!showChanged &&
				!showEqual &&
				!showInReview
			) {
				return true;
			}

			if (!showDeleted && item.resultType === CompareResult.Deleted) {
				return false;
			}

			if (!showNew && item.resultType === CompareResult.New) {
				return false;
			}

			if (!showChanged && item.resultType === CompareResult.Changed) {
				return false;
			}

			if (!showEqual && item.resultType === CompareResult.Equal) {
				return false;
			}

			if (!showInReview && item.resultType === CompareResult.InReview) {
				return false;
			}

			return true;
		});
		return items;
	};

	const filterVexAssigned = useCallback(
		(compareResult: IComparedItem[], showVexAssigned: boolean) => {
			const isMyVexClusterAssigned = (
				paragraph?: IParagraphCompareInput,
			): boolean => {
				return (
					paragraph?.keywordAssignments?.some(ka =>
						ka.vexClusterAssignments?.some(
							vca =>
								vca.vexCluster?.id !== undefined &&
								myVexClusters.some(myVc => myVc.id === vca.vexCluster.id),
						),
					) === true
				);
			};
			if (!showVexAssigned || !isVex) {
				return compareResult;
			}
			return compareResult.filter(
				item =>
					isMyVexClusterAssigned(item?.newParagraph) ||
					isMyVexClusterAssigned(item?.oldParagraph),
			);
		},
		[isVex, myVexClusters],
	);

	return {filterByStatus, filterVexAssigned};
};
